import { getAliquotaINPS } from "../constants/aliquote";

/**
 * Calcola il netto stimato di una singola fattura
 * NON deduce contributiInpsPrecedenti (è deduzione annuale, non per-fattura)
 *
 * @param {number} grossAmount - Importo lordo fattura
 * @param {Object} settings - { profitabilityCoefficient, taxRate, inpsType }
 * @param {number} year - Anno di riferimento per aliquota INPS
 * @returns {{ netto: number, percentuale: number, inps: number, imposta: number }}
 */
export function calcolaNettoFattura(grossAmount, { profitabilityCoefficient, taxRate, inpsType }, year) {
  if (!grossAmount || grossAmount <= 0) {
    return { netto: 0, percentuale: 0, inps: 0, imposta: 0 };
  }

  const imponibile = grossAmount * profitabilityCoefficient;
  const inpsRate = getAliquotaINPS(inpsType, year);
  const inps = imponibile * inpsRate / 100;
  const imposta = imponibile * taxRate / 100;
  const netto = grossAmount - inps - imposta;
  const percentuale = (netto / grossAmount) * 100;

  return { netto, percentuale, inps, imposta };
}
